(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('InImageTypeBService', [
        '$http',
        '$q',
        function($http, $q) {
                this.getDefaultOptions = function() {
                    return {
						creativeWidth: '320',
						creativeHeight: '480',
						minWidth: 160,
						maxWidth: 320,
						minHeight: 240,
						maxHeight: 480,
						closeActionTime: -1,
                    };

                };

            this.generateContent = function(scope, options){
                var template = ``;
                return template;
            };





        },
    ]);
})(window.angular);
